import { DataResponse } from "services/response";
import { BASE_API_URL } from "utils/constants";
import { post, get, deleted, downloadFilePost } from '../../utils/api';


export type GiftModel = {
  stt: number
  id: string
  applicableObject: string
  programName: string
  membershipRank: string
  conversionForm: string
  unit: string
  giftValue: number
  expiryDateFrom: string
  expiryDateTo: string
  createTime: string
  createBy: string
  giftStatus: string
  status: boolean
}

export type ManageRewardModel = {
  stt: number
  exchangeRewardDate: string,
  customerCode: string,
  customerName: string,
  totalRevenue: number,
  aptRevenue: number,
  usedRevenue: number,
  remainValue: number,
  conversionForm: string,
  giftValue: number,
  unit: string

  exchangeRewardCode?: string
}

export type SearchRewardModel = {
  stt: number,
  customerCode: string,
  customerName: string,
  phoneNumber: string,
  programCode: string,
  programName: string,
  totalRevenue: number,
  usedValue: number,
  remainRevenue: number,
  customerId: string,
  programId: string
}

export type GiftDropdownModel = {
  giftId: string, memberRank: string
}

export type RewardModel = {
  customerCode: string
  phone: string
  customerName: string
  totalRevenue: number
  aptRevenue: number
  usedRevenue: number
  remainValue: number
  isAllowExchangeReward: boolean
  gifts: GiftDropdownModel[]
}



// ============ Khai báo phương thức =====================
export interface IExchangeRewardsServices {
  // danh sách quà tặng
  getListGifts: (data: object) => Promise<DataResponse<GiftModel[]>>
  deleteGift: (id: string, typeCode: string) => Promise<DataResponse<null>>
  createGift: (data: object) => Promise<DataResponse<null>>
  detailGift: (id: string) => Promise<DataResponse<GiftModel>>

  // =================================================================================================
  // danh sách quản lí đổi thưởng
  getListManageReward: (data: object) => Promise<DataResponse<ManageRewardModel[]>>
  // tra cứu
  getSearchCustomerExchangeReward: (data: object) => Promise<DataResponse<SearchRewardModel[]>>
  // chi tiết khách hàng đổi thưởng
  getDetailCustomerExchangeReward: (CustomerId?: string, ProgramId?: string, TypeExchangeReward?: string) => Promise<DataResponse<RewardModel>>

  // cập nhật
  updateExchangeReward: (data: object) => Promise<DataResponse<null>>

  // export excel
  exportExcelManageReward: (data: object) => Promise<void>
  // tra cứu đổi thưởng
  exportExcelSearchReward: (data: object) => Promise<void>


  syncRewardCode: (data: object) => Promise<void>
}
// =============================== Hàm khởi tạo các phương thức service =========================================
export function createExchangeRewardsServices(): IExchangeRewardsServices {
  return {
    // danh sách quà tặng
    getListGifts: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/search`, data))
        .data;
    },
    // delete quà tặng
    deleteGift: async (id, typeCode) => {
      return (
        await deleted(
          BASE_API_URL,
          `Gift/delete`, {
          Id: id,
          TypeCode: typeCode
        })
      )
        .data;
    },
    // create quà tặng
    createGift: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/save`, data)
      )
        .data;
    },
    // detail quà tặng
    detailGift: async (id) => {
      return (
        await get(
          BASE_API_URL,
          `Gift/get/` + id)
      )
        .data;
    },
    // =================================================================================================================
    // danh sách quản lí đổi thưởng
    getListManageReward: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/search-exchange-reward`, data))
        .data;
    },
    // tra cứu
    getSearchCustomerExchangeReward: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/search-customer-exchange-reward`, data))
        .data;
    },
    // chi tiết khách hàng đổi thưởng
    getDetailCustomerExchangeReward: async (CustomerId, ProgramId, TypeExchangeReward) => {
      return (
        await get(
          BASE_API_URL,
          `Gift/get-customer-exchange-reward`, {
          CustomerId: CustomerId,
          ProgramId: ProgramId,
          TypeExchangeReward: TypeExchangeReward
        }))
        .data;
    },
    // cập nhật
    updateExchangeReward: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/exchange-reward`, data))
        .data;
    },

    exportExcelManageReward: async (data) => {
      return (
        await downloadFilePost(
          `Gift/export-excel-exchange-reward`, data))
    },
    exportExcelSearchReward: async (data) => {
      return (
        await downloadFilePost(
          `Gift/export-excel-customer-exchange-reward`, data))
    },
    syncRewardCode: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Gift/integration-sap-exchange-reward`, data))
        .data;
    },
  };
}
